import cn from 'classnames'
import React from 'react'

import styles from './MenuHeading.module.scss'

interface MenuHeadingProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'lg'
}

function MenuHeading({ children, size = 'sm', className, ...props }: MenuHeadingProps) {
  return (
    <div className={cn(styles.root, size && styles[`size-${size}`], className)} {...props}>
      {children}
    </div>
  )
}

export default MenuHeading
